import { useState } from "react";
import { Lightbulb, X } from "lucide-react";

// One-time "what's this?" hint per bundle (remembered in localStorage).
export default function BundleHint({ id, children }) {
  const [show, setShow] = useState(() => !localStorage.getItem(`fluent_hint_${id}`));
  if (!show) return null;
  const close = () => { localStorage.setItem(`fluent_hint_${id}`, "1"); setShow(false); };
  return (
    <div className="nb-card bg-butter p-4 mt-4 flex items-start gap-3" data-testid={`bundle-hint-${id}`}>
      <Lightbulb className="w-5 h-5 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm font-medium">{children}</div>
      <button onClick={close} data-testid={`bundle-hint-close-${id}`} className="shrink-0"><X className="w-4 h-4" /></button>
    </div>
  );
}
